import { render, staticRenderFns } from "./HolidayCalendarComponent.vue?vue&type=template&id=08b3e12c&"
import script from "./HolidayCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./HolidayCalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./HolidayCalendarComponent.vue?vue&type=style&index=0&id=08b3e12c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports